export const ROUTES = {
  widget: "/",
  referral: "/link",
} as const;

export interface NavItem {
  to: string;
  label: string;
  title: string;
  caption: string;
}

export const NAV_ITEMS: NavItem[] = [
  {
    to: ROUTES.widget,
    label: "Виджет",
    title: "Конструктор виджетов",
    caption: "Настройте цвета под свой бренд и получите код для вставки",
  },
  {
    to: ROUTES.referral,
    label: "Реферальная ссылка",
    title: "Конструктор реферальных ссылок",
    caption:
      "Настройте параметры и получите готовую ссылку для привлечения клиентов",
  },
];
